import React from "react";

const Numbers = () =>{
    return(
    <>
    <div id="counter" className="theme-bg-default">
    <div className="container">
      <div className="row d-flex align-items-center">
        <div className="col-lg-4">
          <div className="counter-item theme-d-flex align-items-center">
            <div className="counter-icon mdi-rotating-bg rotating-bg-light">
              <i className="flaticon-like-2 mdi-bg mdi-bg-md" />
            </div>
            <div className="counter-content">
              <h2>
                <i className="mdi mdi-plus" />{" "}
                <span className="counter-up">1000</span>
              </h2>
              <h5>Services Rendered</h5>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="counter-item theme-d-flex align-items-center">
            <div className="counter-icon mdi-rotating-bg rotating-bg-light">
              <i className="flaticon-team mdi-bg mdi-bg-md" />
            </div>
            <div className="counter-content">
              <h2>
                <i className="mdi mdi-plus" />{" "}
                <span className="counter-up">1000</span>
              </h2>
              <h5> &nbsp; &nbsp; &nbsp;&nbsp; Clients</h5>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="counter-item theme-d-flex align-items-center">
            <div className="counter-icon mdi-rotating-bg rotating-bg-light">
              <i className="flaticon-trophy mdi-bg mdi-bg-md" />
            </div>
            <div className="counter-content">
              <h2>
                <i className="mdi mdi-plus" />{" "}
                <span className="counter-up">1000</span>
              </h2>
              <h5>Recommendations</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
    )
}

export default Numbers;